import * as React from 'react'

const PlusIcon = ({ color, ...rest }) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <g clipPath="url(#clip0_6359_12043)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 14.25C11.2279 14.25 14.25 11.228 14.25 7.5C14.25 3.77208 11.228 0.749984 7.5 0.749984C3.77208 0.749984 0.749984 3.77208 0.749984 7.5C0.749984 11.2279 3.77208 14.25 7.5 14.25ZM7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35783 11.6421 0 7.5 0C3.35783 0 0 3.35783 0 7.5C0 11.6421 3.35783 15 7.5 15Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 7.49999C10.5 7.70704 10.3321 7.87498 10.125 7.87498H4.87499C4.66787 7.87498 4.5 7.70704 4.5 7.49999C4.5 7.29295 4.66787 7.125 4.87499 7.125H10.125C10.3321 7.125 10.5 7.29295 10.5 7.49999Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.49999 10.5C7.29295 10.5 7.125 10.3321 7.125 10.125V4.87499C7.125 4.66787 7.29295 4.5 7.49999 4.5C7.70704 4.5 7.87498 4.66787 7.87498 4.87499V10.125C7.87498 10.3321 7.70704 10.5 7.49999 10.5Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_6359_12043">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default PlusIcon
